import { StyleSheet, View, Pressable, FlatList, Image, Dimensions } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { sharePlace, toggleFavouriteWorkspace } from "@/layouts/genericPages/helpers/HompageHelpers";
import { BottomNavigationPadding } from "../genericPages/components/FindifyNavigation";
import { FindifyDialog } from "../genericPages/components/FindifyDialog";
import { FindifySimpleHeader, SimpleHeaderAction } from "../genericPages/components/FindifySimpleHeader";
import { BasePage } from "../genericPages/helpers/BasePage";
import { DefaultShadow, IconShadow, TextShadow } from "../genericPages/helpers/DefaultShadows";
import { getTranslatedString } from "../genericPages/helpers/FindifyTranslatedString";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";
import { getApiFromModule } from "../genericPages/helpers/GetContentsByModule";
import { PlaceText } from "../genericPages/components/PlaceText";
import React from "react";
import { getFeaturedImageUrl, makeContentTitle, makeStartTimeString } from "../genericPages/helpers/DetailsHelpers";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { FindifyCMSPage } from "../genericPages/FindifyCMSPage";
import { getWorkspaceDescription, getWorkspaceTitle } from "../genericPages/helpers/WorkspaceText";


type PlacePageHeaderArgs = {
    navigation: any,
    enableDonations: boolean,
    enableSharing: boolean,
    enableDownload: boolean,
    enableFavorites: boolean,
    findifyDataContext: FindifyDataContextType | null,
}
export const PlacePageHeader = ({ navigation,
    enableDonations,
    enableSharing,
    enableDownload,
    enableFavorites,
    findifyDataContext,
}: PlacePageHeaderArgs) => {
    const [dialogCode, setDialogCode] = useState<JSX.Element | null>(null);
    const { t } = useTranslation();
    const [actions, setActions] = useState<SimpleHeaderAction[]>([]);
    const insets = useSafeAreaInsets();

    useEffect(() => {
        const actionsList: SimpleHeaderAction[] = [];
        if (enableSharing) {
            actionsList.push({
                icon: 'share-outline',
                action: () => sharePlace(findifyDataContext)
            });
        }
        if (enableFavorites) {
            const alreadyFavourite = findifyDataContext?.favouriteWorkspaces.includes(findifyDataContext?.workspace?.workspace_id);
            actionsList.push({
                color: alreadyFavourite ? "red" : undefined,
                icon: alreadyFavourite ? 'heart' : 'heart-outline',
                action: () => toggleFavouriteWorkspace(findifyDataContext)
            });
        }
        if (enableDownload) {
            actionsList.push({
                icon: 'download-outline',
                action: () => {
                    setDialogCode(<FindifyDialog
                        onAction1={() => { console.log('action1'); setDialogCode(null) }}
                        onAction2={() => { console.log('action2'); setDialogCode(null) }}
                        action1Text={t('popup.yes')}
                        action2Text={t('popup.no')}
                        message="download outline" />);
                }
            });
        }
        if (enableDonations) {
            actionsList.push({
                icon: 'logo-euro',
                action: () => {
                    setDialogCode(<FindifyDialog
                        onAction1={() => { console.log('action1'); setDialogCode(null) }}
                        onAction2={() => { console.log('action2'); setDialogCode(null) }}
                        action1Text={t('popup.yes')}
                        action2Text={t('popup.no')}
                        message="logo euro" />);
                }
            });
        }
        setActions(actionsList);

    }, [findifyDataContext])

    return <FindifySimpleHeader
        isEventLayout
        navigation={navigation}
        title={getWorkspaceTitle(findifyDataContext)}
        subtitle={getWorkspaceDescription(findifyDataContext)}
        hideGoBack={true}
        logo={findifyDataContext?.workspace?.app_settings?.app_logo_url}
        image={findifyDataContext?.workspace?.app_settings?.app_banner_url}
        actions={actions}
        changePlaceLeft={true}
    />

}

const loadPage = (currentSelectedLine: any, navigation: any, findifyDataContext: FindifyDataContextType | null, homepageItems: any, setHomepageItems: any) => {
    const api = getApiFromModule(currentSelectedLine.module, findifyDataContext);
    let orderby = {};
    let filters: any = { published_eq: 1 };

    if (currentSelectedLine.category && currentSelectedLine.category !== '') {
        filters['categories.category.category_id'] = +currentSelectedLine.category;
    }

    api?.getList(homepageItems[currentSelectedLine.id]?.length ?? 0, 6 * +(currentSelectedLine?.columns ?? 1), null, filters, orderby).then(async (res: any) => {
        setHomepageItems({
            ...homepageItems,
            [currentSelectedLine.id]: [
                ...(homepageItems[currentSelectedLine.id] ?? []),
                ...res.results.map((item: any) => {
                    let dateString = undefined;
                    if (item.start_date) {

                        const dateStart = new Date(item?.start_date);
                        const dateEnd = new Date(item?.end_date);

                        dateString = makeStartTimeString(dateStart) + ' - ' + makeStartTimeString(dateEnd);
                    }
                    return {
                        ...item,
                        id: item.event_id,
                        // title: item.name,
                        image: getFeaturedImageUrl(item),
                        date: dateString,
                        onPress: () => {
                            navigation.push('PlaceContentDetails', {
                                module: currentSelectedLine.module,
                                content_id: item.content_id,
                                page_slug: item.page_slug
                            })
                        }
                    }
                })
            ]
        })
    })
}


export const EventsListItemLine = (numberOfColumns: number, item: any, index: number, findifyDataContext: FindifyDataContextType, totalItems: number, module: string) => {
    const commonContainerStyles = {
        flex: 1,
        backgroundColor: PlaceColors(findifyDataContext).background.get(),
        borderColor: PlaceColors(findifyDataContext).secondary.get(),
        borderWidth: 1,
        borderRadius: 10,
        marginTop: 6,
        overflow: 'hidden',
        width: Dimensions.get('window').width - 12, // 6 + 6
        marginLeft: 6,
        marginRight: 6,
        // marginHorizontal: 6,
        ...DefaultShadow,
    };

    const imageContainerStyles: any = {
        borderRadius: 9,
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
    };

    const titleContainerStyles: any = {

        backgroundColor: PlaceColors(findifyDataContext).secondary.withAlpha(150), // Update this color as needed
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        padding: 4,
    };
    if (numberOfColumns > 1) {
        const margins: any = {};

        if (index % numberOfColumns === 0) { // is left box
            margins.marginRight = 3;
        } else if (index % numberOfColumns === numberOfColumns - 1) { // is left box
            margins.marginLeft = 3;
        } else {
            margins.marginRight = 3;
            margins.marginLeft = 3;
        }

        const width = (Dimensions.get('window').width - 12 - (6 * (numberOfColumns - 1))) / numberOfColumns;

        return (
            <Pressable
                key={`news_index_${index}`}
                style={{
                    ...commonContainerStyles,
                    flex: 1 / numberOfColumns,
                    aspectRatio: 0.9,
                    maxWidth: width,
                    ...margins,
                }}
                onPress={item.onPress}
            >
                <View style={[imageContainerStyles]}>
                    <Image
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        source={{ uri: item.image }}
                    />
                </View>
                <View style={[titleContainerStyles]}>
                    <PlaceText
                        style={{
                            color: PlaceColors(findifyDataContext).text.get(),
                            // textAlign: 'center',
                            fontSize: 16,
                            fontWeight: 'normal',
                        }}
                    >
                        {makeContentTitle(item, module, findifyDataContext)}
                    </PlaceText>
                </View>
            </Pressable>
        );

    } else {
        return (
            <Pressable
                key={`news_index_${index}`}
                style={{
                    ...commonContainerStyles,
                    aspectRatio: 1.7,
                }}
                onPress={item.onPress}
            >
                <View style={[imageContainerStyles]}>
                    <Image
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        source={{ uri: item.image }}
                    />
                </View>

                <View style={[titleContainerStyles]}>
                    {item.date && <PlaceText
                        style={[TextShadow, {
                            color: PlaceColors(findifyDataContext).text.get(),
                            textAlign: 'left',
                            fontSize: 12,
                            fontWeight: 'bold',
                        }]}
                    >
                        {item.date}
                    </PlaceText>}
                    {item.categories && item.categories.length > 0 && <PlaceText
                        style={[TextShadow, {
                            color: PlaceColors(findifyDataContext).text.get(),
                            textAlign: 'left',
                            fontSize: 12,
                        }]}
                    >
                        {item.categories.map((cat: any) => getTranslatedString(cat?.category?.name, findifyDataContext)).join(', ')}
                    </PlaceText>}
                    <PlaceText
                        style={[TextShadow, {
                            color: PlaceColors(findifyDataContext).text.get(),
                            textAlign: 'left',
                            fontSize: 22,
                            marginTop: 4,
                            fontWeight: 'bold',
                        }]}
                    >
                        {makeContentTitle(item, module, findifyDataContext)}
                    </PlaceText>
                    {item.place_address && <PlaceText
                        style={[TextShadow, {
                            color: PlaceColors(findifyDataContext).text.get(),
                            textAlign: 'left',
                            fontSize: 12,
                        }]}
                    >
                        {item.place_address}
                    </PlaceText>}
                </View>
            </Pressable>
        );
    }

}

export const PlaceTab = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();
    const findifyDataContext = useContext(FindifyDataContext);
    const [homepageLines, setHomepageLines] = useState<any[]>([]);
    const [currentSelectedLine, setCurrentSelectedLine] = useState<any>();
    const [homepageItems, setHomepageItems] = useState<any>({});
    const categoriesApi = getApiFromModule('categories', findifyDataContext);
    const { t } = useTranslation();

    useEffect(() => {
        const cats = findifyDataContext.workspace.app_settings?.homepage_lines;
        const catsIds = cats.map((cat: any) => {
            if (cat.category) {
                return +cat.category;
            }
        });
        categoriesApi.getList(0, catsIds.length, null, {
            category_id_in: JSON.stringify(catsIds)
        }, null).then((data: any) => {
            setHomepageLines(cats.map((cat: any) => {
                const catData = data.results.find((item: any) => item.category_id == cat.category);
                return {
                    ...cat,
                    name: catData?.name,
                    image: getFeaturedImageUrl(catData),
                    description: catData?.description,
                    page_slug: catData?.page_slug,
                    category_id: catData?.category_id,
                    category_type: catData?.category_type
                }
            }));
        })
    }, []);

    useEffect(() => {
        if (!currentSelectedLine) {
            setCurrentSelectedLine(homepageLines[0])
        }
    }, [homepageLines])

    return <BasePage navigation={navigation}>
        {/* <FindifyTopBarOverlay /> */}
        {findifyDataContext?.workspace?.app_settings?.homepage_id ? (
            <ScrollView
                bounces={false}
                showsHorizontalScrollIndicator={false}
                showsVerticalScrollIndicator={false}
                style={{ paddingBottom: insets.bottom + BottomNavigationPadding }}
            >
                <PlacePageHeader
                    enableDonations={false}
                    enableSharing={true}
                    enableDownload={false}
                    enableFavorites={true}
                    navigation={navigation}
                    findifyDataContext={findifyDataContext}
                />
                <FindifyCMSPage 
                    pageId={findifyDataContext.workspace.app_settings.homepage_id} 
                    navigation={navigation} 
                />
            </ScrollView>
        ) : (
            <FlatList
                key={'eventsListHP' + (+(currentSelectedLine?.columns ?? 1) > 1 ? 'Dense' : 'Light') + currentSelectedLine?.id}
                data={homepageItems[currentSelectedLine?.id]}
                ListHeaderComponent={() => <>
                    <PlacePageHeader
                        enableDonations={false}
                        enableSharing={true}
                        enableDownload={false}
                        enableFavorites={true}
                        navigation={navigation}
                        findifyDataContext={findifyDataContext}
                    />
                    <FlatList
                        key={'eventsListCategories'}
                        data={homepageLines}
                        horizontal={true}
                        showsHorizontalScrollIndicator={false}
                        showsVerticalScrollIndicator={false}
                        contentContainerStyle={{
                            marginBottom: 10
                        }}
                        renderItem={({ item, index }) => {
                            return <Pressable
                                key={'events_index_' + index}
                                style={{
                                    paddingHorizontal: 5,
                                    paddingVertical: 10,
                                    borderTopWidth: 2,
                                    borderTopColor: item.id === currentSelectedLine?.id ? PlaceColors(findifyDataContext).secondary.get() : 'transparent',
                                }}

                                onPress={() => setCurrentSelectedLine(item)} >
                                <PlaceText style={[TextShadow, {
                                    fontSize: 16,
                                    color: PlaceColors(findifyDataContext).text.get(),
                                }]}>
                                    {
                                        item.name ?
                                            getTranslatedString(item.name, findifyDataContext) :
                                            t('modules.content_types.' + item.module)
                                    }
                                </PlaceText>
                            </Pressable>
                        }}
                    />
                </>
                }
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
                onEndReached={() => {
                    if (currentSelectedLine) {
                        loadPage(currentSelectedLine, navigation, findifyDataContext, homepageItems, setHomepageItems);
                    }
                }}
                numColumns={+(currentSelectedLine?.columns ?? 1)}
                onEndReachedThreshold={0.7}
                renderItem={({ item, index }) => {
                    return EventsListItemLine(+(currentSelectedLine?.columns ?? 1), item, index, findifyDataContext, homepageItems.length, currentSelectedLine.module);
                }}

                bounces={false}
                keyExtractor={(item, index) => index.toString()}
                contentContainerStyle={[{
                    paddingBottom: insets.bottom + BottomNavigationPadding,
                }]}
            />
        )}
    </BasePage>;
};


const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
});
